export const dialog = (() => {
    const openButtons = document.querySelectorAll("[data-dialog]");
    const closeButtons = document.querySelectorAll(".dialog-close");
    let previousFocus;

    const dialog = document.getElementById("dialog");
    if (!dialog) return;

    if (dialog.getAttribute("data-isOpen") === "true") {
        previousFocus = document.activeElement;
        dialog.showModal();
    }

    openButtons.forEach((open) => {
        const dialog = document.getElementById(open.dataset.dialog);
        if (!dialog) return;
        open.addEventListener("click", () => {
            previousFocus = document.activeElement;
            dialog.showModal();
        });
    });

    closeButtons.forEach((close) => {
        const dialog = document.getElementById(close.dataset.dialog);
        if (!dialog) return;
        close.addEventListener("click", () => {
            dialog.close();
            previousFocus.focus();
        });
    });
})();
